const ICONS = {
  // svgs
  baseUrl: "./assets/icons/",// パス（共通部分）
  air: "air_24.svg",
  apps: "apps_24.svg",
  arrowTopRight: "arrow_top_right_24.svg",
  building: "building_24.svg",
  calendarClock: "calendar_clock_24.svg",
  capture: "capture_24.svg",
  cloud: "cloud_24.svg",
  close: "close_24.svg",
  cube: "cube_24.svg",
  directionsBus: "directions_bus_24.svg",
  directionsCars: "directions_cars_24.svg",
  directionsTrain: "directions_train_24.svg",
  directionsWalk: "directions_walk.svg", // ファイル名が_24ではないため
  foggy: "foggy_24.svg",
  fullscreen: "fullscreen_24.svg",
  fullscreenExit: "fullscreen_exit_24.svg",
  help: "help_24.svg",
  history: "history_24.svg",
  hotel: "hotel_24.svg",
  importContacts: "import_contacts_24.svg",
  keyboardArrowUp: "keyboard_arrow_up_24.svg",
  keyboardBackspace: "keyboard_backspace_24.svg",
  layers: "layers_24.svg",
  localCafe: "local_cafe_24.svg",
  localParking: "local_parking_24.svg",
  location: "location_24.svg",
  locationPin: "location_pin_24.svg",
  locationPin2: "location_pin2_24.svg",
  logout: "logout_24.svg",
  mail: "mail_24.svg",
  map: "map_24.svg",
  menu: "menu_24.svg",
  minus: "minus_24.svg",
  mountain: "mountain_24.svg",
  nearMe: "near_me_24.svg",
  nearMeFill: "near_me_fill_24.svg",
  news: "news_24.svg",
  notes: "notes_24.svg",
  notifications: "notifications_24.svg",
  person: "person_24.svg",
  phone: "phone_24.svg",
  plus: "plus_24.svg",
  postOffice: "post_office_24.svg",
  print: "print_24.svg",
  questionMark: "question_mark_24.svg",
  rainy: "rainy_24.svg",
  rainyHeavy: "rainy_heavy_24.svg",
  restaurant: "restaurant_24.svg",
  search: "search_24.svg",
  school: "school_24.svg",
  share: "share_24.svg",
  shieldPerson: "shield_person_24.svg",
  shoppingCart: "shopping_cart_24.svg",
  sitemap: "sitemap_24.svg",
  snowy: "snowy_24.svg",
  star: "star_24.svg",
  store: "store_24.svg",
  sunny: "sunny_24.svg",
  thunder: "thunder_24.svg",
  timeline: "timeline_24.svg",
  tourism: "tourism_24.svg",
  wc: "wc_24.svg",
  weather: "weather_24.svg",
  you: "you_24.svg",

  // pngs
  pngsBaseUrl: "./assets/mapion-ios-icons/",
  default: "default@3x.png",
  boundary: "boudary@3x.png",
  streetName: "street_name@3x.png",
  topography: "topography@3x.png",
  hiragana: "hiragana@3x.png",

  // logo
  logoFullPath: process.env.PUBLIC_URL + "/assets/logo/mapion_logo.png",
  logo: "./assets/logo/mapion_logo.png",
}

export default ICONS;